













import { Component, Vue } from 'vue-property-decorator';

import FeedbackCard from '@/components/FeedbackCard.vue';

@Component({
  components: {
    FeedbackCard,
  },
})
export default class ErrorPage extends Vue {
  private onCancel() {
    this.$router.push({ name: 'pdf' });
  }
}
